import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { getIsLoggedIn } from 'b2b-apps/shop/context/redux/selectors';
import { fetchManufacturer } from 'b2b-apps/shop/manufacturer/redux/manufacturer/actionCreators';
import { getManufacturer } from 'b2b-apps/shop/manufacturer/redux/manufacturer/selectors';
import { ManufacturerType } from 'b2b-apps/shop/manufacturer/redux/manufacturer/types';

type UseManufacturerEffectReturnType = RemoteRecord<ManufacturerType>;

const useManufacturerEffect = (
  manufacturerId: string,
): UseManufacturerEffectReturnType => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const manufacturer = useSelector((state) => getManufacturer(state, manufacturerId));

  useEffect(
    () => {
      dispatch(fetchManufacturer(manufacturerId));
    },
    [
      dispatch,
      isLoggedIn,
      manufacturerId,
    ],
  );

  return manufacturer;
};

export type { UseManufacturerEffectReturnType };
export { useManufacturerEffect };
